import { gql } from "@apollo/client";

export const newHolidayMutation = gql`
mutation($input: [HolidayInput!]!){
  newHoliday(input: $input) {
    message
    response
  }
}
`;


export const updateHolidayMutation = gql`
mutation($input: HolidayInput!){
  updateHoliday(input: $input) {
    message
    response
  }
}
`;

export const deleteHolidayMutation = gql `
mutation($deleteHolidayId: String!){
  deleteHoliday(id: $deleteHolidayId) {
    message
    response
  }
}
`;

export const updateHolidaySettingsMutation = gql`
mutation($input: HolidaySettingsInput!){
  updateHolidaySettings(input: $input) {
    message
    response
  }
}
`;

export const saveEmployeeHolidaySettingMutation = gql`
mutation($input: EmployeeHolidaySettingInput!){
  saveEmployeeHolidaySetting(input: $input) {
    message
    response
  }
}
`;

export const addHolidayAdjustmentMutation = gql`
mutation($input: HolidayAdjustmentInput!){
  addHolidayAdjustment(input: $input) {
    message
    response
  }
}
`;

export const deleteHolidayAdjustmentMutation = gql`
mutation($id: String!){
  deleteHolidayAdjustment(id: $id) {
    message
    response
  }
}
`;

export const createHolidayRequestMutation = gql`
mutation($input: HolidayRequestInput!){
  createHolidayRequest(input: $input) {
    message
    response
  }
}
`;

export const updateHolidayRequestMutation = gql`
mutation($id: String!, $input: HolidayRequestInput!){
  updateHolidayRequest(id: $id, input: $input) {
    message
    response
  }
}
`;

export const approveHolidayRequestMutation = gql`
mutation($id: String!, $note: String, $days: Float, $hours: Float, $payRate: Float, $payCurrency: String, $payRateNote: String){
  approveHolidayRequest(id: $id, note: $note, days: $days, hours: $hours, payRate: $payRate, payCurrency: $payCurrency, payRateNote: $payRateNote) {
    message
    response
  }
}
`;

export const rejectHolidayRequestMutation = gql`
mutation($id: String!, $note: String){
  rejectHolidayRequest(id: $id, note: $note) {
    message
    response
  }
}
`;

export const cancelHolidayRequestMutation = gql`
mutation($id: String!, $note: String){
  cancelHolidayRequest(id: $id, note: $note) {
    message
    response
  }
}
`;


export const setHolidayPayRatesMutation = gql`
mutation($input: [HolidayPayRateInput!]!){
  setHolidayPayRates(input: $input) {
    message
    response
  }
}
`;
